// extracted by mini-css-extract-plugin
export default {"marquee":"cBfSqNo3","items":"ibYTHDth","desktop":"desktop","mobile":"mobile","item":"h8FdM7jL","shadow":"EvvtbtI9","under":"Qlqb__uQ"};